import { Component, OnInit, Input } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { Observable, Subscription, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DateFormatService } from '@/app/services/date-format.service';
import { BriefSectionComponent } from '@/app/components/projects/project-development/tendering/project-expression-of-interest/brief-section/brief-section.component';
import { PrintService } from '@/app/services/shared/print.service';
@Component({
  selector: 'app-eoi-view',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    BriefSectionComponent,
  ],
  templateUrl: './eoi-view.component.html',
  styleUrl: './eoi-view.component.css',
})
export class EoiViewComponent implements OnInit {
  @Input() eoiId!: number;
  eoiSubmittedData;
  projectIdNew: number;
  constructor(
    private projectsService: ProjectsService,
    public dialog: MatDialog,
    private GetProjectIdService: GetProjectIdService,
    private activeRoute: ActivatedRoute,
    private tenderingService: TenderingService,
    private sanitizer: DomSanitizer,
    private dateFormatService: DateFormatService,
    private printService: PrintService
  ) {}

  isDialogOpen = false;
  applicantViewData: any;
  private subscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.getApplicantEoiView();
    this.getSubmittedEoiData();
    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = +id;
      if (!this.projectIdNew) {
        this.projectIdNew = +this.GetProjectIdService.getProjectId();
      }
      this.getApplicantEoiView();
      this.getSubmittedEoiData();
    });
  }

  getApplicantEoiView() {
    if (this.projectIdNew) {
      this.tenderingService
        .getCurrentEoiResponse(this.projectIdNew, this.eoiId)
        .subscribe({
          next: (data) => {
            this.applicantViewData = data?.data;

            if (data?.data?.country_id) {
              this.getCountryData(this.applicantViewData.country_id).subscribe(
                (countryName) => {
                  if (countryName) {
                    data.data.country_id = countryName;
                    this.applicantViewData = data?.data;
                  } else {
                    console.log('No country data available for the given ID.');
                  }
                }
              );
            }
          },
          error: (error) => {
            console.error('Error fetching Applicant View data:', error);
          },
        });
    }
  }

  getSubmittedEoiData() {
    if (this.projectIdNew) {
      return this.tenderingService
        .getSubmittedEoiInitiationData(this.projectIdNew, this.eoiId)
        .subscribe({
          next: (response) => {
            this.eoiSubmittedData = response.data;
          },
          error: (error) => {
            console.error('Error fetching data:', error);
          },
        });
    }
  }

  getCountryData(country_id: any): Observable<any> {
    return this.projectsService.getCountry(country_id).pipe(
      map((data: any) => data?.data?.name), // Extract the country name
      catchError((error) => {
        console.error('Error fetching country data:', error);
        return of(null); // Return a default value or `null` on error
      })
    );
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }
  transformDate(date: Date | string): string {
    return this.dateFormatService.formatDate(date);
  }

  print() {
    this.printService.printContent('printEoi', 'eoi');
  }
}
